import getEnvVar from '@utils/getEnvVar';
import * as Sentry from '@sentry/vue';
import Vue from 'vue';

export default () => {
  if (!['local', 'test'].includes(getEnvVar('SENTRY_ENVIRONMENT'))) {
    Sentry.init({
      Vue,
      dsn: getEnvVar('SENTRY_DSN'),
      environment: getEnvVar('SENTRY_ENVIRONMENT'),
    });
  }
};
